import React from "react";
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import CommonTable from '../../../components/CommonTable/CommonTable';
import cs from '../../../components/commonStyle.css';
import cx from 'classnames';
import { getCarDocuments } from "../../../actions/getCarDocuments";
import { connect } from "react-redux";
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import messages from '../../../locale/messages';
import s from './CarDocumentList.css';

// Update document status API
import { updateStatus } from '../../../actions/updateStatus';
import history from "../../../core/history";


const categoryDisplayNames = {
  PROOF_OF_OWNERSHIP: "Proof of Ownership",
  PROOF_OF_MAINTENANCE: "Proof of Maintenance",
  PROOF_OF_INSURANCE: "Proof of Insurance",
  // Add more mappings as needed
};

class CarDocumentList extends React.Component {
  // Single document status update handler

  static propTypes = {
    updateStatus: PropTypes.func.isRequired,
    getCarDocuments: PropTypes.func.isRequired,
    listId: PropTypes.number, // or string, depending on your usage
    intl: PropTypes.object.isRequired,
  };


  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      loading: true,
      updatingId: null,
      modalOpen: false,
      modalDoc: null,
      modalType: null, // 'image' or 'pdf'
      selectedRows: [], // array of selected document ids
      bulkUpdating: false // true when bulk approve is in progress
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleSelectRow = this.handleSelectRow.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleBulkAction = this.handleBulkAction.bind(this);
  }
  
 

  handleOpenModal(url, type) {
    this.setState({ modalOpen: true, modalDoc: url, modalType: type });
  }

  handleCloseModal() {
    this.setState({ modalOpen: false, modalDoc: null, modalType: null });
  }

  // Removed handleStatusChange and handleUpdate, not needed anymore as status change is instant in dropdown

  thead() {
    const { formatMessage } = this.props.intl;
    const { documents, selectedRows } = this.state;
    // Select all logic: checked if all visible docs are selected, indeterminate if some
    const allIds = documents.map(doc => doc.id);
    const allSelected = allIds.length > 0 && allIds.every(id => selectedRows.includes(id));
    const someSelected = selectedRows.length > 0 && !allSelected;
    return [
      { data: (
        <input
          type="checkbox"
          checked={allSelected}
          ref={el => { if (el) el.indeterminate = someSelected; }}
          onChange={this.handleSelectAll}
          style={{ margin: 0 }}
          aria-label="Select all documents"
        />
      ) },
      { data: formatMessage(messages.carDocumentList_upload_file) },
      { data: formatMessage(messages.carDocumentList_category) },
      { data: formatMessage(messages.carDocumentList_status) },
      { data: formatMessage(messages.carDocumentList_action) },
    ];
  }

  handleSelectRow(docId) {
    this.setState(prevState => {
      const selectedRows = prevState.selectedRows.includes(docId)
        ? prevState.selectedRows.filter(id => id !== docId)
        : [...prevState.selectedRows, docId];
      return { selectedRows };
    });
  }

  handleSelectAll(e) {
    const { documents } = this.state;
    if (e.target.checked) {
      this.setState({ selectedRows: documents.map(doc => doc.id) });
    } else {
      this.setState({ selectedRows: [] });
    }
  }

  
  getBulkActionType() {
    const { documents, selectedRows } = this.state;
    if (!selectedRows.length) return 'approve';
    const selectedDocs = documents.filter(doc => selectedRows.includes(doc.id));
    const allApproved = selectedDocs.every(doc => doc.status === 'approved');
    const allRejected = selectedDocs.every(doc => doc.status === 'rejected');
    if (allApproved) return 'reject';
    if (allRejected) return 'approve';
    return 'approve'; // default for pending/mixed
  }

  async handleBulkAction() {
  const { documents, selectedRows } = this.state;
  const { listId, updateStatus } = this.props;
  const actionType = this.getBulkActionType();
  const targetStatus = actionType === 'approve' ? 'approved' : 'rejected';
  const docsToUpdate = documents.filter(doc => selectedRows.includes(doc.id) && doc.status !== targetStatus);
  const idsToUpdate = docsToUpdate.map(doc => doc.id);
  if (!idsToUpdate.length) return;
  this.setState({ bulkUpdating: true });
  try {
    const updateResult = await updateStatus(listId, null, targetStatus, idsToUpdate);
    console.log('Update result:', updateResult);
    
    await this.fetchUploadedDocument(); // Always fetch after update
    this.setState({ selectedRows: [], bulkUpdating: false });
  } catch (error) {
    this.setState({ bulkUpdating: false, selectedRows: [] });
    console.error('Error in handleBulkAction:', error);
  }
}
  tbody() {
    const { documents, updatingId, selectedRows, bulkUpdating } = this.state;
    const { formatMessage } = this.props.intl;
    return documents.map(doc => {
      const key = `${doc.listId}_${doc.category}`;
      const isChecked = selectedRows.includes(doc.id);
      return {
        id: doc.id,
        data: [
          // Checkbox column
          {
            data: (
              <input
                type="checkbox"
                checked={isChecked}
                disabled={bulkUpdating}
                onChange={() => this.handleSelectRow(doc.id)}
                aria-label={`Select document ${doc.category}`}
                style={{ margin: 0 }}
              />
            )
          },
          // File display: show image preview if image, else download link
          { data: (
            doc.uploadFile ? (
              (() => {
                const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
                const pdfExtensions = ['pdf'];
                const url = doc.uploadFile;
                const ext = url.split('.').pop().split('?')[0].toLowerCase();
                if (imageExtensions.includes(ext)) {
                  return (
                    <img
  src={url}
  alt={doc.category || 'car document'}
  style={{
    maxWidth: '80px',
    maxHeight: '60px',
    objectFit: 'contain',
    borderRadius: 4,
    border: '1px solid #eee',
    cursor: bulkUpdating ? 'not-allowed' : 'pointer',
    pointerEvents: bulkUpdating ? 'none' : 'auto',
    zIndex: 2,
    position: 'relative',
  }}
  tabIndex={0}
  title={doc.category || 'car document'}
  onClick={e => {
    e.stopPropagation();
    console.log('Image clicked', url);
    if (!bulkUpdating) {
      this.handleOpenModal(url, 'image');
    }
  }}
/>
                  );
                }
                if (pdfExtensions.includes(ext)) {
                  return (
                    <div style={{ position: 'relative', width: '80px', height: '60px', border: '1px solid #eee', borderRadius: 4, overflow: 'hidden' }}>
                      <iframe
                        src={url}
                        title={doc.category || 'PDF document'}
                        style={{ width: '80px', height: '60px', border: 'none', borderRadius: 4 }}
                      />
                      {/* Overlay to capture click and open modal */}
                      <div
                        onClick={() => this.handleOpenModal(url, 'pdf')}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          cursor: 'pointer',
                          background: 'rgba(0,0,0,0)',
                        }}
                        title={doc.category || 'PDF document'}
                      />
                    </div>
                  );
                }
                // Static file icon for non-image/non-pdf files
                return (
                  <span title={doc.category || 'file'} style={{ display: 'inline-block', width: 32, height: 32, verticalAlign: 'middle' }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="#f2f2f2"/>
                      <path d="M8 3v18M16 3v18" stroke="#ccc"/>
                      <path d="M3 8h18M3 16h18" stroke="#ccc"/>
                    </svg>
                  </span>
                );
              })()
            ) : null
          ) },
          { data: categoryDisplayNames[doc.category] || doc.category },
          {
            data: (
              <span
                className={cx({
                  [cs.statusPending]: doc.status === 'pending',
                  [cs.statusApproved]: doc.status === 'approved',
                  [cs.statusRejected]: doc.status === 'rejected',
                })}
                style={{
                  padding: '4px 12px',
                  borderRadius: '12px',
                  fontWeight: 600,
                  background: doc.status === 'approved' ? '#e6f9f1' : doc.status === 'rejected' ? '#fdeaea' : '#f8f9fa',
                  color: doc.status === 'approved' ? '#17a673' : doc.status === 'rejected' ? '#e74c3c' : '#888',
                  fontSize: 13
                }}
              >
                {doc.status === 'approved' ? 'Approved' : doc.status === 'rejected' ? 'Rejected' : 'Pending'}
              </span>
            )
          },
          {
            
              // Download link with icon
               data: (
                doc.uploadFile ? (
                  <a href={doc.uploadFile} download target="_blank" rel="noopener noreferrer" title={formatMessage(messages.carDocumentList_download)}>
                    {/* Simple download icon (SVG) */}
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                  </a>
                ) : null
              ) },
            
          
        ]
      };
    });
  }

  async fetchUploadedDocument() {
    console.log('fetchUploadedDocument called');
   
    const { listId } = this.props;
    this.setState({ loading: true });
    try {
      let documents = await this.props.getCarDocuments('', listId);
      // Default sort: pending first, then approved, then rejected
      const sortOrder = { pending: 0, approved: 1, rejected: 2 };
      documents = (documents || []).slice().sort((a, b) => (sortOrder[a.status] ?? 3) - (sortOrder[b.status] ?? 3));
      console.log('Fetched documents after update:', documents);
      this.setState({
        documents,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
      console.error('DocumentVerification: fetchUploadedDocument error:', error);
    }
  }

  async componentDidMount() {
    
    await this.fetchUploadedDocument();
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { loading, modalOpen, modalDoc, modalType, selectedRows, bulkUpdating } = this.state;
    return (
      <div className={s.pagecontentWrapper}>
        {/* Bulk Approve button */}
        <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 12 }}>
  <button
    type="button"
    className={cs.btnPrimary}
    style={{ minWidth: 100 }}
    onClick={() => { history.push('/siteadmin/listings'); }}
  >
    {formatMessage(messages.carDocumentList_back) || 'Back'}
  </button>
  <button
    type="button"
    className={cs.btnPrimary}
    disabled={selectedRows.length === 0 || bulkUpdating}
    onClick={this.handleBulkAction}
    style={{ minWidth: 120 }}
  >
    {bulkUpdating
      ? (this.getBulkActionType() === 'approve' ? 'Approving...' : 'Rejecting...')
      : (this.getBulkActionType() === 'approve' ? 'Approve Selected' : 'Reject Selected')}
  </button>
  {selectedRows.length > 0 && !bulkUpdating && (
    <span style={{ color: '#888', fontSize: 13 }}>{selectedRows.length} {formatMessage(messages.carDocumentList_selected) || 'selected'}</span>
  )}
</div>
        <CommonTable
          thead={() => this.thead()}
          tbody={() => this.tbody()}
          title={formatMessage(messages.carDocumentList) || 'Car Document Approvals'}
          badgeCount={this.state.documents.filter(d => d.status === 'pending').length}
        />
        {loading && <div>{formatMessage(messages.carDocumentList_loading)}</div>}
        {modalOpen && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }} onClick={this.handleCloseModal}>
            <div style={{
              background: '#fff',
              padding: 16,
              borderRadius: 6,
              minWidth: 320,
              maxWidth: '90vw',
              maxHeight: '90vh',
              position: 'relative',
              boxShadow: '0 2px 16px rgba(0,0,0,0.3)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }} onClick={e => e.stopPropagation()}>
              <button onClick={this.handleCloseModal} style={{position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', fontSize: 20, cursor: 'pointer'}}>×</button>
              {modalType === 'image' && (
                <img src={modalDoc} alt="document preview" style={{ maxWidth: '80vw', maxHeight: '80vh', borderRadius: 4, border: '1px solid #eee' }} />
              )}
              {modalType === 'pdf' && (
                <iframe src={modalDoc} title="PDF preview" style={{ width: '80vw', height: '80vh', border: 'none', borderRadius: 4 }} />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
const mapDispatch = {
 
  getCarDocuments,
  updateStatus,
};

const mapState = (state) => ({
});
export default connect(
  mapState,
  mapDispatch
)(withStyles(s, cs)(injectIntl(CarDocumentList)));
